import React from "react"
import arrowRight from '../../../../assets/images/icons/arrow-badge-right.png'
import { useNavigate } from "react-router-dom";

const Header = ({activeIndex, setActiveIndex}) => {
  const navigate = useNavigate();
  const steps = [
    { name: 'Select a Marketing Channel', },
    { name: 'Simple Setup' },
    { name: 'Review/Submit' }
  ]

  const renderBackButton = (clickHandler) => {
      return (
          <button
              onClick={clickHandler}
              className="back-arrow-btn"
              style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  marginRight: '1rem',
                  padding: 0
              }}
              aria-label="Go back"
          >
              &lt;
          </button>
      );
  }

  return (
    <div className="marketing__header">
      <div className="cts-container">
        <div className="d-flex justify-content-center align-items-center gap-16">
            {activeIndex === 1 && (
                renderBackButton(() => navigate('/marketing'))
            )}
            {activeIndex >= 2 && (
                renderBackButton(() => setActiveIndex(activeIndex - 1))
            )}
           {steps.map((step, index) => (
              <React.Fragment key={index}>
                <p className={activeIndex >= index ? 'active' : '' }>
                  <span className="d-none d-lg-block">Step {index + 1}: </span> {step?.name}
                </p>

                {index + 1  < steps.length && (
                  <img src={arrowRight} alt="arrow right" />
                )}
              </React.Fragment>
            ))}
        </div>
      </div>
    </div>
  );
}

export default Header
